import React, { Fragment } from "react"

import clsx from "clsx"
import { convertOrderCombosToCartCombos } from "utils"
import OrderDetailsItem from "./OrderDetailsItem"
import classes from "./OrderDetailsItems.module.scss"

const OrderDetailsItems = props => {
  const { order, subPaymentItems } = props

  const orderItems =
    order.items.filter(item =>
      !item.comboSet
    )

  const orderCombos =
    convertOrderCombosToCartCombos(order.items)

  return (
    <Fragment>
      {orderItems.map((orderItem, i) => (
        <div
          key={i}
          className={clsx(
            i !== order.items.length - 1 && classes.marginBottom
          )}
        >
          <OrderDetailsItem
            orderItem={orderItem}
            isPaid={
              subPaymentItems?.[orderItem._id]?.paymentStatus === "paid"
            }
          />
        </div>
      ))}

      {orderCombos.map((orderCombo, orderComboIndex) =>
        <div
          key={orderComboIndex}
          className={classes["combo"]}
        >
          <div className={classes["comboCode"]}>
            {orderCombo.name}
          </div>
          <div>
            {orderCombo.items.map(comboItem =>
              <div
                key={comboItem.option._id}
                className={classes["comboItem"]}
              >
                <OrderDetailsItem
                  orderItem={comboItem}
                  isPaid={
                    subPaymentItems?.[comboItem.orderItemId]?.paymentStatus === "paid"
                  }
                />
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  )
}

export default OrderDetailsItems